// extracted by mini-css-extract-plugin
module.exports = {"root":"DealersList_root__g8kM6","list":"DealersList_list__GYsVE","loader":"DealersList_loader__ChDCy","error":"DealersList_error__OoqWH"};